const Game = () => {
    return <h1>game</h1>;
  };
  
  export default Game;